<template>
  <v-card elevation="3" class="rounded-xl">
    <v-row class="my-0">
      <v-col cols="12">
        <v-card-title v-if="percentDif > 0 && chartValues.length > 0">
          Membership
          <v-icon class="mdi mdi-arrow-down success--text mb-1" size="15"></v-icon>
          <span class="success--text">{{ percentDif }}%</span>
        </v-card-title>
        <v-card-title v-if="percentDif < 0 && chartValues.length > 0">
          Membership
          <v-icon class="mdi mdi-arrow-up error--text mb-1" size="15"></v-icon>
          <span class="error--text">{{ Math.abs(percentDif) }}%</span>
        </v-card-title>
        <v-card-title v-if="percentDif === 0 && chartValues.length > 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                Membership
                <v-icon class="mdi mdi-swap-vertical mb-1" size="15"></v-icon> -
              </span>
            </template>
            <span>Less than 1% change</span>
          </v-tooltip>
        </v-card-title>
        <v-alert type="info" v-if="chartValues.length === 0">No Data for selected input</v-alert>
        <v-card-title v-if="chartValues.length < 1">
          Membership
          <v-divider class="my-2"></v-divider>
        </v-card-title>
      </v-col>
    </v-row>
    <bar-chart
      :data="dataCollection"
      :options="options"
      :styles="chartStyles"
      :chart="'membership'"
    />
  </v-card>
</template>

<script>
import BarChart from '../charts/BarChart';

export default {
  components: {
    BarChart,
  },
  props: ['chartInfo', 'view'],
  data() {
    return {
      dataCollection: null,
      dashboardRange: null,
      chartMonths: [],
      chartValues: [],
      lineColor: '#4C69C5',
      percentDif: 0,
      loading: false,
      cancelSource: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: 'Months',
              },
              gridLines: {
                color: 'rgba(61, 97, 133, 0.25)',
                display: true,
                drawBorder: false,
                drawTicks: false,
              },
              ticks: {
                padding: 10,
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Membership',
              },
              gridLines: {
                color: 'rgba(61, 97, 133, 0.25)',
                display: true,
                drawBorder: false,
                drawTicks: false,
              },
              ticks: {
                padding: 10,
                precision: 0,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.chartMonths = [];
      this.chartValues = [];

      this.chartInfo.forEach((info) => {
        this.chartMonths.push(info.month);
        this.chartValues.push(info.membership);
      });

      this.getPercentDif();
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: 'Membership',
            data: this.chartValues,
            borderColor: this.lineColor,
            borderWidth: 3,
            borderRadius: 3,
          },
        ],
      };
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1]
        ? this.chartValues[this.chartValues.length - 1]
        : 0;

      const decreaseValue = firstVal - lastVal;

      this.percentDif =
        firstVal !== 0
          ? Math.ceil((decreaseValue / firstVal) * 100)
          : Math.ceil(decreaseValue * 100);

      this.loading = false;
    },
  },
  computed: {
    chartStyles() {
      if (this.view === 'dashboard') {
        return {
          height: '100%',
        };
      } else {
        return {
          height: '25vh',
        };
      }
    },
  },
  watch: {
    async chartValues() {
      this.chartData();
    },
    async chartInfo() {
      this.getData();
    },
    async dashboardRange() {
      this.$emit('dashboardRange', this.dashboardRange);
    },
  },
};
</script>
